import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import {
  Field,
  FieldArray,
  FieldArrayRenderProps,
  useFormikContext,
} from "formik";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { currency } from "../../../MUI_components/currencyFormatterTag";
import { Delete } from "@mui/icons-material";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { System } from "titum-custom/details";
import { PAYMENT_TYPE } from "Components/Constants/PaymentType";
import { DEFAULT_VALUES } from "Components/Constants/defaultValues";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import SalesReturnService from "Service/Invoice/SalesReturn.service";
import { PAYMENT_TYPE_CODE } from "Components/Constants/PaymentTypeCode";
import { CUSTOMER_CONST } from "Components/Constants/CustomerContsnt";
import { PRINT_TYPE } from "Components/Constants/PrintType";
import Swal from "sweetalert2";
import { useHotkeys } from "react-hotkeys-hook";

interface PaymentFieldArrayProps extends FieldArrayRenderProps {
  initialValues?: {
    values: any; // Adjust the type according to your actual data structure
  };
}

export default function Payments(props: any) {
  const {
    billTotal,
    isValid,
    onSubmit,
    setPrintType,
    customer,
    returnTotal,
    setReturnTotal,
    balaceWithReturn,
    invoiceValue,
    setInvoiceValue,
    setReturnCode,
    returnCode,
    discountTotal,
    setModeOfPayment,
    setSms,
    phone1: initialPhone1, // Ensure default value is set if not provided
  } = props;

  const banks = useSelector((state: any) => state.bank);
  const paymentTypes = useSelector((state: any) => state.paymentType);
  const [loading, setLoading] = useState(false);
  const [phone1, setPhone1] = useState(initialPhone1); // Initialize phone1 state
  // console.log("initialPhone1:", initialPhone1);

  const today = new Date().toISOString().split("T")[0];
  const [balanceToPay, setBalanceToPay] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const dispatch = useDispatch();
  const [modeofpaymentt, setModeofpaymentt] = useState([]);
  const { setFieldValue } = useFormikContext();

  const [initPayment, setInitPayment] = useState({
    amount: "",
    paidStatus: 0,
    paymentType: "",
    phone1: null,
    remarks: "",
    bankDeposit: {
      date: "",
      refNumber: "",
      bank: "",
    },
    chequePayment: {
      chequeDate: "",
      bank: "",
      chequeNumber: "",
    },
    cardPayment: {
      refNumber: "",
      cardNumber: "",
      bank: "",
      balanceToPay: balanceToPay,
    },
    onlineTransfer: {
      transferDate: "",
      bank: "",
      transferId: "",
    },
  });

  useEffect(() => {
    setFieldValue("phone1", phone1);
    // console.log("phone1:", phone1);
  }, [phone1, setFieldValue]);

  const receivedAmountValidation = (values: any) => {
    let isValid = false;
    const cashPaymentMode = values.modeOfPayments
      .filter((row: any) => row.paymentType == PAYMENT_TYPE_CODE.CASH_PAYMENT)
      .map((elem: any) => elem.amount)
      .reduce((acc: any, sum: any) => acc + sum, 0);

    let receivedAmount = values.receivedAmount;

    if (cashPaymentMode > 0) {
      if (!receivedAmount || receivedAmount == 0) {
        isValid = false;
        dispatch(openSnackbar(true, "info", "Please Enter Received Amount"));
      } else if (receivedAmount < cashPaymentMode) {
        isValid = false;
        dispatch(
          openSnackbar(true, "info", "Please Enter Valid Received Amount")
        );
      } else {
        isValid = true;
      }
    } else {
      isValid = true;
    }

    return isValid;
  };

  const handleReturnAmount = async () => {
    try {
      setLoading(true);

      const res = await SalesReturnService.get(returnCode);

      if (!res) {
        dispatch(
          openSnackbar(true, "error", "Please Enter Valid Sales Return Code")
        );
        setLoading(false);
        setReturnCode("");
        return;
      }

      if (res.isSetteled == true) {
        dispatch(
          openSnackbar(
            true,
            "error",
            "This sales return has already been used for a settled invoice."
          )
        );
        setReturnCode("");
        setLoading(false);
      } else {
        setReturnTotal(res.totalAmount);
        setLoading(false); // Ensure loading state is reset after setting return total
      }
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
      setLoading(false); // Ensure loading state is reset in case of an error
    }
  };

  const validateContactAssignment = (
    fieldArrayProps: PaymentFieldArrayProps
  ) => {
    if (fieldArrayProps.initialValues?.values.phone1 == null) {
      Swal.fire({
        title: "Please assign the contact",
        icon: "info",
      });
      return false;
    }
    return true;
  };

  const checkValidInvoicePhoneNumber = (
    fieldArrayProps: PaymentFieldArrayProps
  ) => {
    if (props.customer) {
      if (props.customer.code === CUSTOMER_CONST.CASH_CUSTOMER) {
        alert('"SMS" : Cash pay not applicable for sending SMS');
        return false;
      } else if (!props.customer.phone1) {
        alert("Please assign the SMS reg. number");
        return false;
      } else {
        return true;
      }
    } else {
      return validateContactAssignment(fieldArrayProps); // ✅ call the function and return its result
    }
  };

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // const focusInput = () => {
      inputRef.current?.focus();
    // };

    // // Initial focus
    // focusInput();

    // // Re-focus if blurred
    // const inputEl = inputRef.current;
    // inputEl?.addEventListener("blur", focusInput);

    // return () => {
    //   inputEl?.removeEventListener("blur", focusInput);
    // };
  }, [modeofpaymentt.length > 1]);
  // modeofpaymentt > 1
  // console.log(modeofpaymentt);

  return (
    <FieldArray name="payment">
      {(fieldArrayProps) => {
        const { form } = fieldArrayProps;
        const { values, isSubmitting } = form;

        const paymentWithoutReturn = values.modeOfPayments
          .map((payment: any) => payment.amount)
          .reduce((sum: any, i: any) => sum + i, 0);

        const paymentTotal = paymentWithoutReturn + parseFloat(returnTotal);

        const totalwithoutCard = values.modeOfPayments
          .filter(
            (row: any) =>
              !row.cardPayment.refNumber &&
              !row.cardPayment.cardNumber &&
              !row.cardPayment.bank
          )
          .map((elem: any) => elem.amount)
          .reduce((acc: any, sum: any) => acc + sum, 0);
        let cardPaymentExists = false;

        cardPaymentExists =
          values.payment.paymentType &&
          values.payment.paymentType ===
            paymentTypes.filter(
              (paymentType: any) => paymentType.name === "Card"
            )[0]["code"];

        let paymentByCard = billTotal - totalwithoutCard - returnTotal;

        const balanceAmount = billTotal - paymentTotal;

        const discountTotalforCard = 0.3 * discountTotal;
        const billTotalwithCardDiscount = billTotal + discountTotalforCard;
        const totalWithCard =
          (billTotalwithCardDiscount / billTotal) * balanceAmount;
        const billTotalWithCardPayment = parseFloat(
          Math.round(totalWithCard).toFixed(2)
        );
        let cardPaymentExistsInModeOfPayment = values.modeOfPayments.filter(
          (row: any) => row.cardPayment.bank
        ).length;

        let balanceToPay =
          cardPaymentExists == true
            ? -billTotalWithCardPayment
            : paymentTotal - billTotal;

        if (cardPaymentExistsInModeOfPayment > 0) {
          //Disable opt remoive card option
          if (paymentTotal - billTotal > 0) {
            balanceToPay = 0;
          }
        }
        setBalanceToPay(balanceToPay);

        const checkvalidPayment = () => {
          // alert("Enter key pressed")
          let deuAmount =
            balanceToPay > 0 ? billTotal + balanceToPay : billTotal;
          // console.log("deuAmount" + deuAmount);
          if (paymentTotal >= deuAmount) {
            // console.log("paymentTotal" + paymentTotal);
            return true;
          }

          return false;
        };
        const validPayment = checkvalidPayment();

        // console.log(validPayment);

        /**
         * Logic: During the partial-payment, once the card-payment is method selected with other-payment types, 
                  Card option needs to be hide from the list of Payment Type.
         * Step 1: Verify that, is Card payment method already exists or not in list-of-payments in table using
                  isCardPaymentTypeExistInBillTotalTable. 
         * Step 2: If the length of isCardPaymentTypeExistInBillTotalTable > 0, filter other-payment methods,
                  except 'Card' from paymentTypes array. (newPaymentTypes)
        */
        const isCardPaymentTypeExistInBillTotalTable =
          values.modeOfPayments.filter(
            (paymentMethod: any) =>
              paymentMethod.paymentType == PAYMENT_TYPE_CODE.CARD_PAYMENT
          );

        const excludePaymentTypes = [
          PAYMENT_TYPE.CASH_PAYMENT,
          PAYMENT_TYPE.CHEQUE_PAYMENT,
          PAYMENT_TYPE.CARD_PAYMENT,
          PAYMENT_TYPE.BANK_DEPOSIT,
          PAYMENT_TYPE.ONLINE_TRANSFER,
        ];

        const filteredFinalPaymentTypes = paymentTypes.filter(
          (paymentType: { code: bigint; name: string }) =>
            excludePaymentTypes.includes(paymentType.name)
        );

        const newPaymentTypes =
          isCardPaymentTypeExistInBillTotalTable.length > 0
            ? filteredFinalPaymentTypes.filter(
                (paymentType: { code: bigint; name: string }) =>
                  paymentType.name !== PAYMENT_TYPE.CARD_PAYMENT
              )
            : paymentTypes;

        return (
          <div
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.altKey && e.key === "Enter") {
                if (
                  checkValidInvoicePhoneNumber({
                    ...fieldArrayProps,
                    initialValues: { values: form.values },
                  }) &&
                  validPayment
                ) {
                  setModeOfPayment(true);
                  setPrintType(PRINT_TYPE.POS);
                  onSubmit();
                  setSms(true);
                }
              }
              if (e.key === "+") {
                if (validPayment) {
                  setPrintType(PRINT_TYPE.POS);
                  onSubmit();
                  setModeOfPayment(false);
                  setSms(false);
                }
              }
            }}
          >
            <div className="row">
              {/* <div className="col-9">
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Sales Return Code"
                  value={returnCode}
                  onChange={(e: any) => setReturnCode(e.target.value)}
                />
              </div>
              <div className="col-3">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleReturnAmount}
                  disabled={loading || !returnCode}
                >
                  Return Amount
                </Button>
              </div> */}
            </div>
            <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
              {values.payment.paymentType &&
                values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Card"
                  )[0]["code"] && (
                  <div style={{ color: "red" }}>
                    With Card Payment : {currency(billTotalWithCardPayment)}{" "}
                  </div>
                )}
              <div className="col-12">
                <Field name="phone1">
                  {({ field }: { field: any }) => (
                    <TextField
                      {...field}
                      label="Contact"
                      variant="outlined"
                      onChange={(e) => {
                        setFieldValue("phone1", e.target.value); // Update Formik state
                        setPhone1(e.target.value); // Update local state if needed
                      }}
                    />
                  )}
                </Field>
              </div>
              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Bill Total"
                  value={currency(billTotal)}
                  disabled
                />
              </div>
              <div className="col-12">
                {/* <TextField
                  variant="standard"
                  fullWidth
                  label="Return Total"
                  value={currency(returnTotal)}
                  disabled
                /> */}
              </div>

              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Balance"
                  value={currency(balanceToPay)}
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FormControl
                  control="select"
                  label="Payment Type"
                  options={newPaymentTypes}
                  name="payment.paymentType"
                />
                {!values.payment.paymentType && (
                  <span
                    style={{
                      color: "#FF0000",
                      marginTop: 5,
                      display: "block",
                    }}
                  >
                    Please select a payment type.
                  </span>
                )}
              </div>
              <div className="col-6">
                <FormControl
                  control="currency"
                  nested
                  disabled={!values.payment.paymentType}
                  name="payment.amount"
                  label={`Paid Amount ${
                    values.payment.paymentType ==
                    paymentTypes.filter(
                      (paymentType: any) =>
                        paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                    )[0]["code"]
                      ? values.customer?.overPayment
                      : values.payment.paymentType ==
                        paymentTypes.filter(
                          (paymentType: any) =>
                            paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                        )[0]["code"]
                      ? values.customer?.returnAmount
                      : ""
                  }`}
                  onChange={(e: any) => {
                    const amount = Number(e.target.value.replace(/,/g, ""));;
                    // console.log(billTotalWithCardPayment);

                    console.log(amount)
                    console.log(billTotalWithCardPayment)

                    if (amount > billTotalWithCardPayment) {
                      dispatch(
                        openSnackbar(
                          true,
                          "error",
                          "The value entered is greater than the allowed amount"
                        )
                      );
                      
                      if (
                        values.payment.paymentType ==
                        PAYMENT_TYPE_CODE.CARD_PAYMENT
                      ) {
                        setFieldValue(
                          "payment.amount",
                          billTotalWithCardPayment
                        );
                      } else {
                        setFieldValue("payment.amount", balanceToPay);
                      }
                    } else {
                      setPaidAmount(amount);
                      // setFieldValue("payment.amount", amount);
                    }
                  }}
                />
              </div>
            </div>
            {values.payment.paymentType && (
              <>
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Cheque"
                  )[0]["code"] && (
                  <FieldArray name="payment.chequePayment">
                    {(chequePaymentProps) => {
                      return (
                        <div className="row">
                          <div className="col-4">
                            <FormControl
                              control="select"
                              label="Bank"
                              options={banks}
                              name="payment.chequePayment.bank"
                            />
                            {/* <span></span> */}
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              label="Cheque Number"
                              name="payment.chequePayment.chequeNumber"
                            />
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              type="date"
                              label="Cheque Date"
                              name="payment.chequePayment.date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                min: today,
                              }}
                            />
                          </div>
                        </div>
                      );
                    }}
                  </FieldArray>
                )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Bank Deposit"
                  )[0]["code"] && (
                  <FieldArray name="payment.bankDeposit">
                    {(bankDepositProps) => {
                      return (
                        <div className="row">
                          <div className="col-4">
                            <FormControl
                              control="select"
                              label="Bank"
                              options={banks}
                              name="payment.bankDeposit.bank"
                            />
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              label="Ref Number"
                              name="payment.bankDeposit.refNumber"
                            />
                          </div>
                          <div className="col-4">
                            <FormControl
                              control="input"
                              name="payment.bankDeposit.date"
                              label="Deposited Date"
                              type="date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>
                        </div>
                      );
                    }}
                  </FieldArray>
                )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Card"
                  )[0]["code"] && (
                  <FieldArray name="payment.cardPayment">
                    {(cardPaymentProps) => {
                      return (
                        <>
                          <div className="row">
                            <div className="col-4">
                              <FormControl
                                control="select"
                                label="Bank"
                                options={banks}
                                name="payment.cardPayment.bank"
                              />
                              {!values.payment.cardPayment.bank && (
                                <small
                                  style={{ color: "#FF0000", marginTop: 8 }}
                                >
                                  Please select the bank to proceed!
                                </small>
                              )}
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                label="Ref Number"
                                name="payment.cardPayment.refNumber"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="number"
                                label="Card Number (Last 4 digit)"
                                name="payment.cardPayment.cardNumber"
                              />
                            </div>
                          </div>
                        </>
                      );
                    }}
                  </FieldArray>
                )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Online Transfer"
                  )[0]["code"] && (
                  <FieldArray name="payment.onlineTransfer">
                    {() => {
                      return (
                        <>
                          <div className="row">
                            <div className="col-4">
                              <FormControl
                                control="select"
                                label="Bank"
                                options={banks}
                                name="payment.onlineTransfer.bank"
                                required
                                // onChange={handleDataChange}
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                label="Transfer Id"
                                name="payment.onlineTransfer.transferId"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                name="payment.onlineTransfer.transferDate"
                                label="Transfer Date"
                                type="date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </div>
                          </div>
                        </>
                      );
                    }}
                  </FieldArray>
                )}
              </>
            )}
            <div className="row">
              <div className="col-12">
                <FormControl
                  ref={inputRef}
                  control="input"
                  name="payment.remarks"
                  label="Remarks"
                />
              </div>
            </div>
            <FieldArray name="modeOfPayments">
              {({ push, remove }) => (
                <>
                  <div className="row flex-end mb">
                    <Button
                      style={{ display: "flex", flexDirection: "column" }}
                      type="submit"
                      disabled={
                        !values.payment.amount ||
                        !values.payment.paymentType ||
                        (values.payment.paymentType == 21910000002 &&
                          (!values.payment.chequePayment.bank ||
                            !values.payment.chequePayment.chequeNumber ||
                            !values.payment.chequePayment.date)) ||
                        (values.payment.paymentType == 21910000003 &&
                          (!values.payment.bankDeposit.bank ||
                            !values.payment.bankDeposit.refNumber ||
                            !values.payment.bankDeposit.date)) ||
                        (values.payment.paymentType == 21910000004 &&
                          !values.payment.cardPayment.bank) ||
                        // ||
                        // !values.payment.cardPayment.refNumber ||
                        // !values.payment.cardPayment.cardNumber
                        (values.payment.paymentType == 21910000007 &&
                          (!values.payment.onlineTransfer.bank ||
                            !values.payment.onlineTransfer.transferId ||
                            !values.payment.onlineTransfer.transferDate))
                      }
                      variant="contained"
                      onClick={() => {
                        if (
                          values.payment.paymentType ==
                            paymentTypes.filter(
                              (paymentType: any) =>
                                paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                            )[0]["code"] &&
                          values.payment.amount > values.customer.overPayment
                        ) {
                          alert(
                            "The value entered is greater than available amount"
                          );
                          return;
                        } else if (
                          values.payment.paymentType ==
                            paymentTypes.filter(
                              (paymentType: any) =>
                                paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                            )[0]["code"] &&
                          values.payment.amount <= values.customer.overPayment
                        ) {
                          values.customer.overPayment =
                            values.customer.overPayment - values.payment.amount;
                        }

                        if (
                          values.payment.paymentType ==
                            paymentTypes.filter(
                              (paymentType: any) =>
                                paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                            )[0]["code"] &&
                          values.payment.amount > values.customer.returnAmount
                        ) {
                          alert(
                            "The value entered is greater than available amount"
                          );
                          return;
                        } else if (
                          values.payment.paymentType ==
                            paymentTypes.filter(
                              (paymentType: any) =>
                                paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                            )[0]["code"] &&
                          values.payment.amount <= values.customer.returnAmount
                        ) {
                          values.customer.returnAmount =
                            values.customer.returnAmount -
                            values.payment.amount;
                        }
                        push({
                          ...values.payment,
                        });
                        setFieldValue("payment", initPayment);
                        setFieldValue("payment.amount", "");
                        setFieldValue("payment.remarks", "");
                      }}
                      color="secondary"
                    >
                      Add
                      {/* <span>[ Space ]</span> */}
                    </Button>
                  </div>
                  <div className="row">
                    {/* <div className="col-6">
                      <FormControl
                        control="currency"
                        name="receivedAmount"
                        label="Received Amount"
                        value={values.receivedAmount}
                      />
                    </div>
                    <div className="col-6">
                      <FormControl
                        control="currency"
                        name="balanceToPay"
                        label="Balance To Pay"
                        disabled
                        value={
                          values.receivedAmount -
                          values.modeOfPayments
                            .filter((row: any) => row.paymentType == PAYMENT_TYPE_CODE.CASH_PAYMENT)
                            .map((elem: any) => elem.amount)
                            .reduce((acc: any, sum: any) => acc + sum, 0)
                        }
                      />
                    </div> */}
                  </div>
                  <div className="row">
                    <TableContainer>
                      <Table
                        aria-labelledby="tableTitle"
                        size={"small"}
                        aria-label="enhanced table"
                      >
                        <TableHead style={{ backgroundColor: "#eee" }}>
                          <TableRow hover role="checkbox" tabIndex={-1}>
                            <TableCell width={10}>
                              {values.modeOfPayments.length > 0 && (
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {}}
                                >
                                  <Delete />
                                </div>
                              )}
                            </TableCell>
                            <TableCell>#</TableCell>
                            <TableCell>{COLUMNS_NAME.REMARKS}</TableCell>
                            <TableCell>{COLUMNS_NAME.PAYEMENT_TYPE}</TableCell>
                            <TableCell align="right">
                              {COLUMNS_NAME.SETTELED_AMOUNT}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values.modeOfPayments.length > 0 &&
                            setModeofpaymentt(values.modeOfPayments)}
                          {values.modeOfPayments.map(
                            (payment: any, index: any) => {
                              // console.log(payment);
                              return (
                                <TableRow
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index}
                                >
                                  <TableCell width={10}>
                                    <Delete
                                      color="secondary"
                                      style={{
                                        fontSize: 18,
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        Swal.fire({
                                          title: `Are you sure?`,
                                          text: `Are you sure want to delete this?`,
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes",
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            remove(index);
                                          }
                                        });
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell width={10}>{index + 1}</TableCell>
                                  <TableCell>{payment.remarks}</TableCell>
                                  <TableCell>
                                    {
                                      paymentTypes.filter(
                                        (paymentType: any) =>
                                          paymentType.code ===
                                          payment.paymentType
                                      )[0]["name"]
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {currency(payment.amount)}
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                          {!values.modeOfPayments.length ? (
                            <TableRow>
                              <TableCell colSpan={5} align="center">
                                No items to display
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} />
                              <TableCell align="left">
                                <strong>Total</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>{currency(paymentTotal)}</strong>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </>
              )}
            </FieldArray>
            {System.SYSTEM_EDITION === SYSTEM_EDITIONS.BIZ_X_AUTO_CARE ? (
              <div className="flex" style={{ margin: 20 }}>
                <button
                  type="button"
                  disabled={
                    isSubmitting ||
                    !values.modeOfPayments.length ||
                    billTotalWithCardPayment < billTotalWithCardPayment
                  }
                  onClick={() => {
                    setPrintType("DOT");
                    onSubmit();
                  }}
                  className="btn-success button"
                >
                  PrintBill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      ""
                    )}
                  </span>
                </button>
              </div>
            ) : (
              <div className="flex" style={{ margin: 20 }}>
                <button
                  type="button"
                  disabled={!validPayment}
                  onClick={() => {
                    if (
                      checkValidInvoicePhoneNumber({
                        ...fieldArrayProps,
                        initialValues: { values: form.values },
                      })
                    ) {
                      setModeOfPayment(true);
                      setPrintType(PRINT_TYPE.POS);
                      onSubmit();
                      setSms(true);
                    }
                  }}
                  className="btn-success button"
                >
                  pos bill + sms
                  <span>
                    {isSubmitting ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      "[ ALT + Enter ]"
                    )}
                  </span>
                </button>
                <button
                  type="submit"
                  disabled={!validPayment}
                  onClick={() => {
                    setPrintType(PRINT_TYPE.POS);
                    onSubmit();
                    setModeOfPayment(false);
                    setSms(false);
                  }}
                  className="btn-success button"
                >
                  pos bill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      "[ + ]"
                    )}
                  </span>
                </button>
              </div>
            )}
          </div>
        );
      }}
    </FieldArray>
  );
}
